"use client";
import React from "react";
import { Pagination } from "antd";
import { ChevronRight, ChevronLeft } from "lucide-react";

export default function CustomPagination({ currentPage, pageSize, totalItems, onPageChange }) {
  if (totalItems <= pageSize) return null; 

  return (
    <div className="fa-pagination">
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={totalItems}
        onChange={onPageChange}
        showSizeChanger={false}
        itemRender={(page, type, originalElement) => {
          if (type === "prev") return <a><ChevronLeft/></a>;
          if (type === "next") return <a><ChevronRight/></a>;
          return originalElement;
        }}
      />
    </div>
  );
}
